<template>
    <div class="bg-cover min-h-app flex items-center" :style="'background-image: url(' + $asset('/hkcm/images/auth.png', 'public') + ')'">
        <div class="container mx-auto my-16">
            <div class="w-full">
                <div class="bg-white p-4 rounded-md shadow-md w-full lg:w-1/3 mx-auto">
                    <h1>{{ $t('plain_newsletter') }}</h1>
                    <p class="mt-4">
                        {{ $t('sign_up_for_newsletter') }}
                    </p>
                    <Newsletter :placeholder="$t('newsletter_enter_email')" redirect="/" innerClass="placeholder:!text-blue placeholder:italic !text-blue" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {};
</script>
